<ion-content class="modal-content">
  <div class="modal-container w-full">
    <h3 class="modal-title">{{ "edit-profile-form.gender.title" | translate }}</h3>
    <div class="gender-options">
      <div
        class="gender-option"
        [class.selected]="selectedGender === 'female'"
        (click)="select('female')"
      >
        <div class="custom-radio"></div>
        <span>{{ "edit-profile-form.gender.female" | translate }}</span>
      </div>

      <div
        class="gender-option"
        [class.selected]="selectedGender === 'male'"
        (click)="select('male')"
      >
        <div class="custom-radio"></div>
        <span>{{ "edit-profile-form.gender.male" | translate }}</span>
      </div>

      <div
        class="gender-option"
        [class.selected]="selectedGender === 'other'"
        (click)="select('others')"
      >
        <div class="custom-radio"></div>
        <span>{{ "edit-profile-form.gender.other" | translate }}</span>
      </div>
    </div>
  </div>
</ion-content>
